import { render, staticRenderFns } from "./ResearcherUniRequestDetails.vue?vue&type=template&id=00c36195&scoped=true&"
import script from "./ResearcherUniRequestDetails.vue?vue&type=script&lang=js&"
export * from "./ResearcherUniRequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherUniRequestDetails.vue?vue&type=style&index=0&id=00c36195&prod&lang=scss&"
import style1 from "./ResearcherUniRequestDetails.vue?vue&type=style&index=1&id=00c36195&prod&lang=scss&scoped=true&"
import style2 from "./ResearcherUniRequestDetails.vue?vue&type=style&index=2&id=00c36195&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c36195",
  null
  
)

export default component.exports